import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: () => import("@/components/Login")
    },
    {
      path: '/index',
      component: () => import("@/components/layout/init"),
      redirect: '/main',
      meta: {title: '初始化组件'},
      children: [
        // 主页
        {
          path: '/main',
          name: 'main',
          component: () => import("@/components/main/Index"),
          meta: {title: '个人中心'}
        },
        {
          path: '/depart',
          name: 'depart',
          component: () => import("@/components/sys/departs"),
          meta: {title: '组织机构管理'}
        },
        {
          path: '/users',
          name: 'users',
          component: () => import("@/components/sys/user"),
          meta: {title: '用户及权限管理'}
        },
        {
          path: '/dicts',
          name: 'dicts',
          component: () => import("@/components/sys/dict"),
          meta: {title: '数据字典管理'}
        },
        {
          path: '/standardIndex',
          name: 'standardIndex',
          component: () => import("@/components/standard/index"),
          meta: {title: '工作量化标准管理'}
        },
        {
          path: '/fillingIn',
          name: 'fillingIn',
          component: () => import("@/components/standard/fillingIn"),
          meta: {title: '工作上报管理'}
        }
        ,
        {
          path: '/report',
          name: 'report',
          component: () => import("@/components/report/report"),
          meta: {title: '统计分析'}
        },
        {
          path: '/params',
          name: 'params',
          component: () => import("@/components/sys/params"),
          meta: {title: '系统参数管理'}
        },
        {
          path: '/task',
          name: 'task',
          component: () => import("@/components/task/task"),
          meta: {title: '日常上报工作'}
        },
        {
          path: '/temp',
          name: 'temp',
          component: () => import("@/components/task/temp"),
          meta: {title: '临时上报工作'}
        },
        {
          path: '/taskQuery',
          name: 'taskQuery',
          component: () => import("@/components/query/taskQuery"),
          meta: {title: '日常上报统计'}
        },
        {
          path: '/tempQuery',
          name: 'tempQuery',
          component: () => import("@/components/query/tempQuery"),
          meta: {title: '临时上报统计'}
        },
        {
          path: '/totalQuery',
          name: 'totalQuery',
          component: () => import("@/components/query/totalQuery"),
          meta: {title: '工作汇总统计'}
        },
      ]
    }
  ]
})


// 设置全局的前置导航守卫
// router.beforeEach((to, from, next) => {
//   // 如果跳转的目的路径是 login 界面, 不做操作
//   if (to.path === '/') {
//     next()
//   } else {
//     /**
//      * 如果是其他界面, 判断本地是否存在 Token
//      * 如果存在, 则正常跳转
//      * 否则重定向到 login 界面
//      */
//     let token = sessionStorage.getItem('Authorization')
//     if (!token) {
//       next('/')
//     } else {
//       next()
//     }
//   }
// })

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js